import { useRerenderComponentWhenMicroFrontendIsLoaded } from "../../../hooks/mff-loaded";
import { getEnvVars, getMicroFrontendDataFromId } from "../../../config/env";
import {
  ADR_MFF_ID,
  AI_MFF_ID,
  API_GW_MFF_ID,
  DATA_CATALOGUE_GW_MFF_ID,
  MASTER_DATA_MFF_ID,
  TLM_MFF_ID,
} from "../../../data/microfrontend-types";
import { useGetFeatureToggleState } from "../../../hooks/feature-toggles";

export default function useHeaderMenuController() {
  useRerenderComponentWhenMicroFrontendIsLoaded();
  const { unificationConfig } = getEnvVars();
  const isApiUnificationToggleEnabled = useGetFeatureToggleState("Neo_ApiPlatform_Unification");
  const isAdrMicroFrontendToggleEnabled = useGetFeatureToggleState("Neo_AdrMicroFrontend_Addition");
  const isAiMicroFrontendToggleEnabled = useGetFeatureToggleState("Neo_AiMicroFrontend_Addition");
  const isTlmMicroFrontendToggleEnabled = useGetFeatureToggleState("Neo_TlmMicroFrontend_Addition");

  return {
    isApiUnificationToggleEnabled,
    isAdrMicroFrontendToggleEnabled,
    isAiMicroFrontendToggleEnabled,
    isTlmMicroFrontendToggleEnabled,
    apiGwMenus: getMicroFrontendDataFromId(API_GW_MFF_ID)?.getHeaderMenus() ?? null,
    adrMenus: getMicroFrontendDataFromId(ADR_MFF_ID)?.getHeaderMenus() ?? null,
    masterDataMenus: getMicroFrontendDataFromId(MASTER_DATA_MFF_ID)?.getHeaderMenus() ?? null,
    aiWorksMenus: getMicroFrontendDataFromId(AI_MFF_ID)?.getHeaderMenus() ?? null,
    dataCatalogueMenus: getMicroFrontendDataFromId(DATA_CATALOGUE_GW_MFF_ID)?.getHeaderMenus() ?? null,
    tlmMenus: getMicroFrontendDataFromId(TLM_MFF_ID)?.getHeaderMenus() ?? null,
    environmentConfig: { ...unificationConfig.environmentSpecificConfig },
  };
}
